import { TRPCClientError } from '@trpc/client';
export const isApiAuthTRPCError = (err) => {
    const isTrpcError = err instanceof TRPCClientError;
    if (!isTrpcError) {
        return false;
    }
    const { data } = err;
    if (!('props' in data)) {
        return false;
    }
    if (typeof data.props !== 'object' || data.props === null) {
        return false;
    }
    return 'code' in data.props && data.props.code === 'ApiAuthError';
};
